// CNPJ alfanumérico e chave de acesso com letras — espelho de backend/app/utils/cnpj.py
// (manter os dois iguais). NT Conjunta 2025.001: 12 letras/números + 2 DV numéricos;
// DV módulo 11 com cada caractere valendo ASCII − 48 (A=17, B=18...); chave
// [0-9]{6}[A-Z0-9]{12}[0-9]{26}. Só com dígitos, o resultado é o de sempre.

export const RE_CNPJ = /^[0-9A-Z]{12}[0-9]{2}$/;
export const RE_CHAVE = /^[0-9]{6}[0-9A-Z]{12}[0-9]{26}$/;
const PESOS_CNPJ = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const valor = (c) => c.charCodeAt(0) - 48;

// Sem máscara e em maiúsculas; letras e dígitos ficam.
export function limparDoc(v) {
  return String(v ?? '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();
}

export function dvCnpj(base12) {
  const base = limparDoc(base12);
  if (!/^[0-9A-Z]{12}$/.test(base)) return null;
  let dvs = '';
  for (const n of [12, 13]) {
    const corpo = base + dvs;
    const pesos = PESOS_CNPJ.slice(-n);
    let soma = 0;
    for (let i = 0; i < n; i++) soma += valor(corpo[i]) * pesos[i];
    const resto = soma % 11;
    dvs += resto < 2 ? '0' : String(11 - resto);
  }
  return dvs;
}

export function cnpjValido(v) {
  const c = limparDoc(v);
  if (!RE_CNPJ.test(c) || c === '00000000000000') return false;
  return dvCnpj(c.slice(0, 12)) === c.slice(12);
}

// 'CPF' (11 dígitos), 'CNPJ' (14 no formato da NT) ou null. Não confere DV.
export function tipoDocumento(v) {
  const d = limparDoc(v);
  if (/^[0-9]{11}$/.test(d)) return 'CPF';
  if (RE_CNPJ.test(d)) return 'CNPJ';
  return null;
}

// Tira máscara e o prefixo "NFe" do Id (só se sobrarem 47 caracteres: um CNPJ
// alfanumérico pode começar com N, F, E).
export function limparChave(v) {
  const s = limparDoc(v);
  return s.length === 47 && s.startsWith('NFE') ? s.slice(3) : s;
}

export function dvChave(chave43) {
  let soma = 0;
  for (let i = 0; i < chave43.length; i++) {
    soma += valor(chave43[chave43.length - 1 - i]) * (2 + (i % 8));
  }
  const dv = 11 - (soma % 11);
  return dv >= 10 ? '0' : String(dv);
}
